<template>
  <b-card no-body class="h-100">
    <b-card-header>
      <b-card-title>Игроки по месяцам</b-card-title>
      <div v-if="current" class="text-right">
        <h4 class="mb-0" :class="rateClass">{{ formatPercent(current.retention_rate) }}</h4>
        <small class="text-muted">удержание в {{ monthLabel(current.month) }}</small>
      </div>
    </b-card-header>
    <b-card-body class="pt-0">
      <vue-apex-charts v-if="months.length" type="line" height="280" :options="chartOptions" :series="series" />
      <div v-else class="text-center text-muted py-4">Нет данных</div>
      <small class="text-muted d-block mt-50">
        Новые — первая игра в этом месяце; вернувшиеся — играли и в прошлом месяце; ушедшие — играли в прошлом, но не в этом.
        Текущий месяц не полный.
      </small>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { computed } from '@vue/composition-api'
import { $themeColors } from '@themeConfig'
import { formatPercent } from '@/views/finance/utils'
import { monthLabel } from '@/views/dashboard/sifnf/utils'

export default {
  components: {
    BCard, BCardHeader, BCardTitle, BCardBody, VueApexCharts,
  },
  props: {
    retention: { type: Object, default: null },
  },
  setup(props) {
    const months = computed(() => (props.retention && props.retention.months) || [])
    // Показываем удержание за последний ПОЛНЫЙ месяц — текущий ещё набирает игры
    const current = computed(() => {
      const full = months.value.filter(m => !m.partial && m.retention_rate !== null)
      return full.length ? full[full.length - 1] : null
    })
    const rateClass = computed(() => {
      if (!current.value) return ''
      return current.value.retention_rate >= 0.5 ? 'text-success' : 'text-warning'
    })

    const series = computed(() => [
      { name: 'Вернувшиеся', type: 'bar', data: months.value.map(m => m.returning) },
      { name: 'Новые', type: 'bar', data: months.value.map(m => m.new) },
      { name: 'Прочие активные', type: 'bar', data: months.value.map(m => Math.max(0, m.active - m.returning - m.new)) },
      { name: 'Ушедшие', type: 'bar', data: months.value.map(m => -m.churned) },
      {
        name: 'Удержание, %',
        type: 'line',
        data: months.value.map(m => (m.retention_rate === null ? null : Math.round(m.retention_rate * 1000) / 10)),
      },
    ])

    const chartOptions = computed(() => ({
      chart: { type: 'line', stacked: true, toolbar: { show: false } },
      colors: [$themeColors.primary, $themeColors.success, $themeColors.secondary, $themeColors.danger, $themeColors.warning],
      plotOptions: { bar: { columnWidth: '45%', borderRadius: 3 } },
      stroke: { width: [0, 0, 0, 0, 3], curve: 'smooth' },
      markers: { size: [0, 0, 0, 0, 4] },
      dataLabels: { enabled: false },
      xaxis: {
        categories: months.value.map(m => `${monthLabel(m.month)}${m.partial ? '*' : ''}`),
      },
      yaxis: [
        { seriesName: 'Вернувшиеся', labels: { formatter: val => Math.abs(Math.round(val)) } },
        { seriesName: 'Вернувшиеся', show: false },
        { seriesName: 'Вернувшиеся', show: false },
        { seriesName: 'Вернувшиеся', show: false },
        {
          opposite: true, seriesName: 'Удержание, %', min: 0, max: 100, labels: { formatter: val => `${Math.round(val)} %` },
        },
      ],
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: (val, { seriesIndex }) => {
            if (seriesIndex !== 4) return Math.abs(val)
            return val === null || val === undefined ? '—' : `${Math.round(val)} %`
          },
        },
      },
      legend: { position: 'top' },
    }))

    return {
      months, current, rateClass, series, chartOptions, formatPercent, monthLabel,
    }
  },
}
</script>
